import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useFinishPayment = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.payments.finishPayment(id, data),
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при завершении платежа',
        description: err.message,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['paymentCard', id] })
    },
  })
}
